import { useI18n } from '@/client/i18n/I18nContext';
import { UI_LOCALES } from '@/client/i18n/dictionary';

export function LanguageSwitcher() {
  const { locale, setLocale, t } = useI18n();
  return (
    <div
      className="lang-switch"
      role="group"
      aria-label={t('common.language')}
    >
      {UI_LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          className={l === locale ? 'is-active' : ''}
          aria-pressed={l === locale}
          onClick={() => setLocale(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
